import { useDispatch } from 'react-redux';
import { useAsyncAction } from 'Hooks/Common';
import { TemplateMergePayload } from 'Interfaces/Document';
import { $actions } from 'Store/ducks';

export default () => {
  const dispatch = useDispatch();

  return useAsyncAction((payload: TemplateMergePayload) =>
    $actions.document.mergeTemplate(dispatch, payload),
  );
};
